import { takeLatest, select, call, put } from "redux-saga/effects";
import { toast } from "@grandvisionhq/common";
import { optIns } from "../../customer-service.js";
import { getAuth, getChangedOptIns } from "../../selectors.js";
import { isLoggedIn } from "../../state.js";
import { createOptInsUpdate } from "../../Util/Util/create-opt-in-updates.js";
import { FETCH_OPT_INS, UPDATE_OPT_INS, fetchOptInsSuccess, fetchOptInsFailed, updateOptInsSuccess, updateOptInsFailed } from "./actions.js";
function* fetchOptIns() {
  try {
    const auth = yield select(getAuth);
    if (!isLoggedIn(auth)) {
      throw new Error(`Can't fetch opt-ins when user isn't logged in`);
    }
    const result = yield call([optIns, "fetch"], auth.apiUrl, auth.userId);
    yield put(fetchOptInsSuccess(result));
  } catch (err) {
    yield put(fetchOptInsFailed(err));
  }
}
function* updateOptIns(action) {
  try {
    const auth = yield select(getAuth);
    if (!isLoggedIn(auth)) {
      throw new Error(`Can't fetch opt-ins when user isn't logged in`);
    }
    let changedOptIns = action.payload;
    if (changedOptIns === void 0) {
      changedOptIns = yield select(getChangedOptIns);
    }
    const updates = yield call(createOptInsUpdate, changedOptIns);
    if (Object.keys(updates).length > 0) {
      const serverOptInsState = yield call([optIns, "fetch"], auth.apiUrl, auth.userId);
      const diff = Object.entries(updates).reduce(
        (acc, [key, optIn]) => (serverOptInsState.optinValues || {})[key] !== optIn.value ? { ...acc, [key]: optIn } : acc,
        {}
      );
      if (Object.keys(diff).length > 0) {
        yield call([optIns, "update"], auth.apiUrl, auth.userId, diff);
      }
      yield put(updateOptInsSuccess());
      yield call(toast.success, "account.updateOptins.success");
    }
  } catch (err) {
    yield put(updateOptInsFailed(err));
  }
}
const optInSagas = [
  takeLatest(FETCH_OPT_INS, fetchOptIns),
  takeLatest(UPDATE_OPT_INS, updateOptIns)
];
export {
  optInSagas as default,
  fetchOptIns,
  updateOptIns
};
//# sourceMappingURL=sagas.js.map
